<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th scope="col" class="nowrap"></th>
                    <th scope="col" class="nowrap">Da</th>
                    <th scope="col" class="nowrap">A</th>
                    <th v-if="data.sampling == 'd'" scope="col" class="nowrap">N. giorni</th>
                    <th v-else-if="data.sampling == 'm'" scope="col" class="nowrap">N. mesi</th>
                    <th v-else-if="data.sampling == 'y'" scope="col" class="nowrap">N. anni</th>
                    <th v-else scope="col" class="nowrap">N. ore</th>
                    <th v-if="data.sampling == 'd'" scope="col" class="nowrap">% giorni</th>
                    <th v-else-if="data.sampling == 'm'" scope="col" class="nowrap">% mesi</th>
                    <th v-else-if="data.sampling == 'y'" scope="col" class="nowrap">% anni</th>
                    <th v-else scope="col" class="nowrap">% ore</th>
                </tr>
            </thead>
            <tbody>
                <tr scope="row" v-for="item, index in thresholdsCorrect" :key="index">
                    <td class="nowrap">{{ item.name }}</td>
                    <td class="nowrap">{{ item.start }}</td>
                    <td class="nowrap">{{ item.end }}</td>
                    <td class="nowrap">{{ item.counter }}</td>
                    <td class="nowrap">{{ item.percentage }}%</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { percent } from '@amcharts/amcharts4/core';
export default {
    name: "ThresholdsTable",
    props: {
        thresholds: {
            type: Array,
            required: false,
        },
        data: {
            type: Object,
            required: false
        },
        areThresholdsPlotted: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            totHours: [],
            percentHours: [],
            thresholdsCorrect: [],
            channelsNumber: 0,
        }
    },
    created() {
        this.initAll();
    },
    methods: {
        initAll() {
            this.thresholdsCorrect = [];
            let counter = 0;
            let maxValue = 0;
            let start = 0;
            let target = 99999999999;

            this.channelsNumber = 0;
            console.log(this.thresholds)
            console.log(this.data)
            if (this.areThresholdsPlotted) {
                this.channelsNumber = this.data.columns.length - this.thresholds.length - 1;
            } else {
                this.channelsNumber = this.data.columns.length - 1;
            }
            

            for(let i = 0; i < this.thresholds.length; i++) {
                let storeCounter = 0;
                start = maxValue;
                for(let j = 0; j < this.channelsNumber; j++) {
                    this.data.values.forEach(valueArr => {
                        const value = valueArr[j + 1];
                        
                        /**
                         * Check if current value is below the current threshold
                         */
                        if(value >= start && value < this.thresholds[i].value) {
                            counter++;
                        }
                        
                        if(i == 0) {
                            if(value && value < target) {
                                target = value;
                            }
                        }
                    });
                    storeCounter = storeCounter + counter;
                }
                console.log("storeCounter", storeCounter)

                if(this.data.sampling == '1') {
                    storeCounter = storeCounter / 60;
                }
                if(this.data.sampling == '15') {
                    storeCounter = storeCounter / 4;
                }

                let percentage = 0;
                if(storeCounter > 0) {
                    percentage = Math.round(((storeCounter / this.data.values.length) * 100));
                }

                storeCounter = Math.round(storeCounter);

                if(i == 0) {
                    this.thresholdsCorrect[i] = { name: this.thresholds[i].name, start: target.toFixed(2), end: this.thresholds[i].value, counter: storeCounter, percentage: percentage };
                }
                this.thresholdsCorrect[i] = { name: this.thresholds[i].name, start: start, end: this.thresholds[i].value, counter: storeCounter, percentage: percentage };

                maxValue = this.thresholds[i].value;
                counter = 0;
                start = 0;
            }
            let endValue = 0;
            for(let k = 0; k < this.channelsNumber; k++) {
                this.data.values.forEach(item => {
                    if(item[k+1] > endValue) {
                        endValue = item[k+1];
                    }
                    if(item[k+1] > maxValue) {
                        counter++;
                    }
                });
            }

            this.thresholdsCorrect.push({ name: "Oltre " + this.thresholds[this.thresholds.length - 1].name, start: maxValue, end: "-", counter: counter });

            let totalCounter = 0;
            this.thresholdsCorrect.forEach(item => {
                totalCounter += parseInt(item.counter);
            })

            for(let l = 0; l < this.thresholdsCorrect.length; l++) {
                if(this.thresholdsCorrect[l].counter > 0) {
                    this.thresholdsCorrect[l].percentage = Math.round((this.thresholdsCorrect[l].counter / totalCounter) * 100);
                } else {
                    this.thresholdsCorrect[l].percentage = 0.00;
                }
            }

            let totalPercentage = 0;
            this.thresholdsCorrect.forEach(item => {
                totalPercentage += parseFloat(item.percentage);
            })

            this.thresholdsCorrect.push({ name: "", start: "", end: "Totale", counter: totalCounter, percentage: totalPercentage.toFixed(0) });
        },
    },

    watch: {
        thresholds() {
            this.initAll();
        },
        filter() {
            this.initAll();
        },
        data() {
            this.initAll();
        }
    }
}
</script>

<style scoped>
.nowrap {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/Types/Am/ThresholdsTable.vue